import { buildRealtimePullRequestId } from '@/lib/realtime/types';

export const PR_V2_CHANGED_DOMAIN = {
  SUMMARY: 'summary',
  DISCUSSION: 'discussion',
  REVIEWS: 'reviews',
  COMMENTS: 'comments',
  CHECKS: 'checks',
  CODE: 'code',
  /** The inbox rows' line counts, which leave out the head's test files. */
  DIFF_STATS: 'diff_stats',
  CUBIC_REVIEW: 'cubic_review',
  AUTO_FIX: 'auto_fix',
} as const;

/** Canonical PR V2 surface areas clients can selectively refresh after a webhook update. */
export const PR_V2_CHANGED_DOMAINS = [
  PR_V2_CHANGED_DOMAIN.SUMMARY,
  PR_V2_CHANGED_DOMAIN.DISCUSSION,
  PR_V2_CHANGED_DOMAIN.REVIEWS,
  PR_V2_CHANGED_DOMAIN.COMMENTS,
  PR_V2_CHANGED_DOMAIN.CHECKS,
  PR_V2_CHANGED_DOMAIN.CODE,
  PR_V2_CHANGED_DOMAIN.DIFF_STATS,
  PR_V2_CHANGED_DOMAIN.CUBIC_REVIEW,
  PR_V2_CHANGED_DOMAIN.AUTO_FIX,
] as const;

/** Narrow union of supported PR V2 refresh domains sent over realtime payloads. */
export type PrV2ChangedDomain = (typeof PR_V2_CHANGED_DOMAIN)[keyof typeof PR_V2_CHANGED_DOMAIN];

export const PR_V2_WEBHOOK_EVENT = {
  MANUAL_MUTATION: 'manual_mutation',
  PULL_REQUEST: 'pull_request',
  REVIEW_STATUS: 'review_status',
  SYNC: 'sync',
} as const;

export type PrV2WebhookEvent = (typeof PR_V2_WEBHOOK_EVENT)[keyof typeof PR_V2_WEBHOOK_EVENT];

export const PR_V2_ACTION = {
  CLOSED: 'closed',
  COMMENT_REACTION_CREATED: 'comment_reaction_created',
  MERGED: 'merged',
  SUMMARY: 'summary',
} as const;

export type PrV2RealtimeAction = (typeof PR_V2_ACTION)[keyof typeof PR_V2_ACTION];

export const PR_V2_UPDATE_SCOPE = {
  DEFAULT: 'default',
  MERGED: 'merged',
} as const;

export type PrV2UpdateScope = (typeof PR_V2_UPDATE_SCOPE)[keyof typeof PR_V2_UPDATE_SCOPE];

export function buildPrV2RealtimePrId(
  owner: string,
  repo: string,
  number: number | string,
): string {
  return buildRealtimePullRequestId(owner, repo, number);
}
